import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';

import { Ads, useAds } from 'api/ads';
import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { AdsCard } from 'widgets/cards';
import { useLanguage } from '../../context/LanguageContext';
import { adsPageLabels } from '../../locales/translations'


export const AdsPage = () => {
    const [adsList, setAdsList] = useState<Ads[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const { language } = useLanguage();
    const title = adsPageLabels.title[language];
    const pageTitle = adsPageLabels.pageTitle[language];
    const metaDescription = adsPageLabels.metaDescription[language];

    const { onGetAllAds } = useAds();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllAds();
                if (result.success) {
                    const filteredAndSortedAds = result.data
                        .filter((ad: Ads) => ad.show) // Оставляем только те объявления, где show === true
                        .sort((a: Ads, b: Ads) => 
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setAdsList(filteredAndSortedAds);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllAds]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {adsList.map((adsItem) => (
                            <GridChild md={3} key={adsItem.id}>
                                <AdsCard adsItem={adsItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
